// +----------------------------------------------------------------------
// | 认证接口
// +----------------------------------------------------------------------
import request from '../lib/request';

/**
 * 注册
 * @param {{username:string, password:string, nickname?:string}} data
 * @returns {Promise<{token:string, expires_in:number, user:object}>}
 */
export function register(data) {
  return request.post('/auth/register', data);
}

/**
 * 登录
 * @param {{username:string, password:string}} data
 * @returns {Promise<{token:string, expires_in:number, user:object}>}
 */
export function login(data) {
  return request.post('/auth/login', data);
}

/**
 * 退出登录（清空服务端 token）
 */
export function logout() {
  return request.post('/auth/logout');
}
